export default {
  header: 'Această săptămână',
  metrics: {
    points: 'Puncte',
    visits: 'Vizite',
    in_store_sign_ups: 'Înregistrări în magazin',
    rewards_redeemed: 'Recompense rascumpărate',
  },
};
